<section class="add-watch-order-container">
  @if (showHeader) {
  <section class="header">
    <span class="title">Add Watch Orders</span>
  </section>
  }
  <section class="references-filter">
    <div class="outline">
      <div class="input-field">
        <mat-slide-toggle
          id="your-reference-toggle"
          [disabled]="!watchReference.length"
          [checked]="isWatchRefEnabled"
          (change)="onWatchReferenceToggleChange()"
          color="primary"
          labelPosition="after"
        >
          Link to Your Reference
        </mat-slide-toggle>
        <mat-form-field appearance="outline" class="form-field">
          <mat-select
            id="your-reference-dropdown"
            [disabled]="!isWatchRefEnabled"
            (selectionChange)="
              onToggleOrderSelection($event.value, watchReferenceField)
            "
            [(value)]="selectedWatchRef"
            multiple
            disableOptionCentering
            placeholder="Select a Reference"
          >
            <mat-select-trigger>
              {{ getDisplayText(watchReferenceField) }}
            </mat-select-trigger>
            @for (wr of watchReference; track wr) {
            <mat-option class="references-filter-option" [value]="wr">
              <mat-checkbox
                color="primary"
                class="filter-checkbox"
                [checked]="selectedWatchRef.includes(wr)"
              >
                <span class="reference-option-label">{{ wr }}</span>
              </mat-checkbox>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="outline">
      <div class="input-field">
        <mat-slide-toggle
          id="sub-client-reference-toggle"
          [disabled]="!subClientReference.length"
          [checked]="isSubClientRefEnabled"
          (change)="onSubClientReferenceToggleChange()"
          color="primary"
          labelPosition="after"
        >
          Link to Sub Client Reference
        </mat-slide-toggle>
        <mat-form-field appearance="outline" class="form-field">
          <mat-select
            id="sub-client-reference-dropdown"
            [disabled]="!isSubClientRefEnabled"
            (selectionChange)="
              onToggleOrderSelection($event.value, subClientReferenceField)
            "
            [(value)]="selectedSubClientRef"
            multiple
            disableOptionCentering
            placeholder="Select a Sub Client Reference"
          >
            <mat-select-trigger>
              {{ getDisplayText(subClientReferenceField) }}
            </mat-select-trigger>
            @for (scr of subClientReference; track scr) {
            <mat-option class="references-filter-option" [value]="scr">
              <mat-checkbox
                color="primary"
                class="filter-checkbox"
                [checked]="selectedSubClientRef.includes(scr)"
              >
                <span class="reference-option-label">{{ scr }}</span>
              </mat-checkbox>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </section>
  <section class="order-grid">
    <div class="grid_outline">
      <div class="quick-filter">
        <mat-form-field appearance="fill" class="quick-filter-input">
          <mat-icon matPrefix>search</mat-icon>
          <input
            id="quick-filter"
            matInput
            placeholder="Find a Watch Order"
            (input)="onQuickFilterChanged($event)"
          />
        </mat-form-field>
      </div>
      <div id="alert-grid">
        <ag-grid-angular
          class="ag-theme-cdx custom-order-grid"
          [rowData]="this.orders$ | async"
          [gridOptions]="gridOptions"
          [animateRows]="true"
          (gridReady)="onGridReady($event)"
          (selectionChanged)="onSelectionChanged()"
        >
        </ag-grid-angular>
        <mat-divider></mat-divider>
        <div class="status-bar">{{ this.selectionCount }} selected</div>
      </div>
    </div>
  </section>
</section>
